const formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'ngaphantsi komzuzwana',
    other: 'ngaphantsi kwemizuzwana eyi-{{count}}',
  },

  xSeconds: {
    one: 'umzuzwana',
    other: 'imizuzwana eyi-{{count}}',
  },

  halfAMinute: 'isiqingatha somzuzu',

  lessThanXMinutes: {
    one: 'ngaphantsi komzuzu',
    other: 'ngaphantsi kwemizuzu eyi-{{count}}',
  },

  xMinutes: {
    one: 'umzuzu',
    other: 'imizuzu eyi-{{count}}',
  },

  aboutXHours: {
    one: 'iyure eyi-1',
    other: 'iiyure eziyi-{{count}}',
  },

  xHours: {
    one: 'iyure eyi-1',
    other: 'iiyure eziyi-{{count}}',
  },

  xDays: {
    one: 'usuku olunye',
    other: 'iintsuku eziyi-{{count}}',
  },

  aboutXMonths: {
    one: 'malunga nenyanga eyi-1',
    other: 'malunga neenyanga eziyi-{{count}}',
  },

  xMonths: {
    one: 'inyanga eyi-1',
    other: 'iinyanga eziyi-{{count}}',
  },

  aboutXYears: {
    one: 'unyaka oyi-1',
    other: 'iminyaka eyi-{{count}}',
  },

  xYears: {
    one: 'unyaka omnye',
    other: 'iminyaka eyi-{{count}}',
  },

  overXYears: {
    one: 'ngaphezu konyaka',
    other: 'ngaphezu kweminyaka eyi-{{count}}',
  },

  almostXYears: {
    one: 'phantse ibe ngunyaka',
    other: 'phantse ibe yiminyaka eyi-{{count}}',
  },
};

export default function formatDistance(token, count, options) {
  options = options || {};

  let result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'kwiintsuku eziyi-' + result;
    }

    return result + ' ezidlulileyo';
  }

  return result;
}
